import { LABEL_ENTITY_ASSIGNMENTS_CHOICE } from './LabelEntityAssignmentsConfirmationModal.constants'

export function isLabelEntityAssignmentsChoiceKeep(choice) {
  return choice === LABEL_ENTITY_ASSIGNMENTS_CHOICE.keep
}

export function getLabelEntityAssignmentsOptions(t) {
  return [
    {
      id: LABEL_ENTITY_ASSIGNMENTS_CHOICE.keep,
      label: t('Label.EditEntityAssignmentsKeepOptionKey'),
    },
    {
      id: LABEL_ENTITY_ASSIGNMENTS_CHOICE.remove,
      label: t('Label.EditEntityAssignmentsRemoveOptionKey'),
    },
  ]
}
